export const educationData = [
    {
        id: 1,
        institution: 'Lebanese International University',
        course: 'Bachelor in Computer Science',
        startYear: '1/10/2016 ',
        endYear: '6/07/2020'
    },

    // {
    //     id: 2,
    //     institution: 'Noakhali Islamia Kamil Madrasah',
    //     course: 'Higher Secondary',
    //     startYear: '2018',
    //     endYear: '2020'
    // },
    // {
    //     id: 3,
    //     institution: 'Baitus Saif Islamia Madrasah',
    //     course: 'Secondary School',
    //     startYear: '2008',
    //     endYear: '2018'
    // },
    
]